'use strict'

function initializeGalleryModal() {
  $(document).ready(function () {
// Initialize Slick Lightbox
    $('#image-gallery').slickLightbox({
      background: 'rgba(0,0,0,.8)',
    });
  })
}

export default initializeGalleryModal
